import { slugs, pages } from '@kit/utils/APIV1'

export const routes = [
  {
    name: 'root',
    path: '/',
    component: () => import(/* webpackChunkName: "root" */'@pages/Home.vue'),
    meta: {
      navColors: {
        navText: "white-green",
        navOptions: "deep-grey-green"
      }
    }
  },


  {
    name: 'contact-us',
    path: '/contact-us',
    component: () => import(/* webpackChunkName: "contact-us" */'@pages/Contact.vue'),
    meta: {
      navColors: {
        navText: "white-green",
        navOptions: "deep-grey-green"
      }
    }
  },

  {
    name: 'dial-a-ride-agencies',
    path: '/agencies/dial-a-ride',
    component:() => import(/* webpackChunkName: "dial-a-ride-page" */'@pages/DialARidePage.vue'),
  },

  {
    name: 'agency-page',
    path: '/agencies/:urlSlug',
    component: () => import(/* webpackChunkName: "agency-page" */'@pages/AgencyPage.vue'),
    meta: {
      sitemap: {
        urlParts: async() => {
          return await slugs('agency-pages')
        }
      },
      navColors: {
        navText: "white-green",
        navOptions: "deep-grey-green"
      }
    }
  },

  {
    name: 'agency-page2',
    path: '/agencies/:urlSlug/:routeID',
    component: () => import(/* webpackChunkName: "agency-page" */'@pages/AgencyPage.vue'),
    meta: {
      sharedRouteName: "agency-page",
      sitemap: {
        urlParts: async() => {
          return await slugs('agency-pages')
        }
      },
      navColors: {
        navText: "white-green",
        navOptions: "deep-grey-green"
      }
    }
  },

  {
    name: 'board-meetings',
    path: '/board-meetings/:page?/:b64SortInfo?',
    component:() => import(/* webpackChunkName: "board-meetings" */'@pages/BoardMeetings.vue'),
    meta: {
      paramsMappedToMultipleSections:true,
      sitemap: {
        urlParts: async() => {
          return await pages('board-meetings')
        }
      }
    }
  },

  {
    name: 'news',
    path: '/news/:page?/:b64SortInfo?',
    component:() => import(/* webpackChunkName: "news" */'@pages/News.vue'),
    meta: {
      paramsMappedToMultipleSections:true,
      sitemap: {
        urlParts: async() => {
          return await pages('news-clips')
        }
      }
    }
  },

  {
    name: 'news-story',
    path: '/news-story/:slug',
    component:() => import(/* webpackChunkName: "news" */'@pages/NewsStory.vue'),
    meta: {
      sitemap: {
        urlParts: async() => {
          return slugs('news-stories')
        }
      }
    }
  },

  {
    name: 'purchase-online',
    path: '/fares/purchase-tickets-online',
    component:() => import(/* webpackChunkName: "purchase-online" */'@pages/PurchaseOnline.vue'),
    meta: {}
  },

  {
    name: 'fares',
    path: '/fares',
    component:() => import(/* webpackChunkName: "fare-page" */'@pages/FarePage.vue'),
  },

  {
    name: 'holidays',
    path: '/how-to-ride/holidays',
    component:() => import(/* webpackChunkName: "holiday-page" */'@pages/HolidayPage.vue'),
  },

  {
    name: 'dial-a-ride',
    path: '/dial-a-ride',
    component:() => import(/* webpackChunkName: "dial-a-ride-page" */'@pages/DialARidePage.vue'),
  },


  {
    name: 'ride-humboldt-flex',
    path: '/ride-humboldt-flex',
    component:() => import(/* webpackChunkName: "ride-humboldt-flex" */'@pages/RideHumboldtFlex.vue'),
  },

  // {
  //   name: 'how-to-ride',
  //   path: '/how-to-ride',
  //   component:() => import(/* webpackChunkName: "hta-page" */'@pages/HTAPage.vue'),
  // },

  {
    name: 'hta-page-slug-and-scroll',
    path: '/:slug/:scrollTo?',
    component:() => import(/* webpackChunkName: "hta-page" */'@pages/HTAPage.vue'),
    meta: {
      sharedRouteName:"hta-page",
      paramsMappedToMultipleSections: true,
      getNonMappedRouteName({ params }) {
        return params.slug
      },
      sitemap: {
        urlParts: async() => {
          return await slugs('hta-page')
        }
      }
    }
  },

  {
    name: 'hta-page-section-slug-and-scroll',
    path: '/:section/:slug/:scrollTo?',
    component:() => import(/* webpackChunkName: "hta-page" */'@pages/HTAPage.vue'),
    meta: {
      sharedRouteName:"hta-page",
      paramsMappedToMultipleSections: true, 
      getNonMappedRoutePath({ params }) {
        return `${params.section}/${params.slug}`
      },
      sitemap: {
        urlParts: async() => {
          return await slugs('hta-page')
        }
      }
    }
  },

  {
    name: 'hta-page-slug',
    path: '/:slug',
    component:() => import(/* webpackChunkName: "hta-page" */'@pages/HTAPage.vue'),
    meta: {
      sharedRouteName:"hta-page",
      sitemap: {
        urlParts: async() => {
          return await slugs('hta-page')
        }
      }
    }
  },

  //{ path: '/public/:which', redirect: '/' }

]